import type {
    SchemaLoanRequestResolver_Find,
    SchemaLoanRequestResolver_GetDuplicateInfoByLead,
    SchemaLoanRequestResolver_GetSummary,
} from 'cpool-tables/backend-resolvers';
import { getAddedAdvisorId, hasMultipleAssignedUsers } from 'cpool-utils';

import { AddedAdvisorLine } from '~/components/AdvisorService/AddedAdvisorLine';
import { AdvisorServiceButton } from '~/components/AdvisorService/AdvisorServiceButton';
import { canHandOnAddedAdvisorShare } from '~/components/AdvisorService/canHandOnAddedAdvisorShare';
import { ChangeAddedAdvisorButton } from '~/components/AdvisorService/ChangeAddedAdvisorButton';
import { AssignedUserSlots } from '~/components/AssignedUsers/AssignedUserSlots';
import { ChangeAdviserButton } from '~/components/AssignedUsers/ChangeAdviserButton';
import { ChangeAssignedUsersButton } from '~/components/AssignedUsers/ChangeAssignedUsersButton';
import { CurrentAdviserName } from '~/components/AssignedUsers/CurrentAdviserName';
import { IKProcessButton } from '~/components/IKProcessButton';

type PropsAdviserAssign = {
    lead:
        | SchemaLoanRequestResolver_GetSummary[number]
        | (SchemaLoanRequestResolver_Find[number] & {
              antragsteller1: NonNullable<SchemaLoanRequestResolver_Find[number]['antragsteller1']>;
          })
        | SchemaLoanRequestResolver_GetDuplicateInfoByLead[number];
    preview?: boolean;
    originalLoanRequestId?: string;
    showIKProcess?: boolean;
    showAdvisorService?: boolean;
};

export const TableColumnAdviserAssign: React.FC<PropsAdviserAssign> = ({
    lead,
    originalLoanRequestId,
    showAdvisorService = false,
    showIKProcess = false,
}) => {
    if (hasMultipleAssignedUsers(lead.type))
        return (
            <div className="flex items-start gap-2 px-4 py-3">
                <div className="min-w-0 max-w-52">
                    <AssignedUserSlots lead={lead} permissions={lead.permissions} />
                </div>
                <div className="flex gap-2 ml-auto">
                    {showIKProcess && 'nextIKCategory' in lead && (
                        <IKProcessButton iconOnly lead={lead} permissions={lead.permissions} />
                    )}
                    <ChangeAssignedUsersButton iconOnly lead={lead} permissions={lead.permissions} />
                </div>
            </div>
        );

    const addedAdvisorId = getAddedAdvisorId(lead);

    return (
        <div className="flex items-start gap-2 px-4 py-3">
            <div className="flex flex-col gap-1 min-w-0 max-w-52">
                <CurrentAdviserName lead={lead} />
                <AddedAdvisorLine lead={lead} />
            </div>
            {/* stacked, right-aligned: Beratungsservice above the pencil */}
            <div className="flex flex-col items-end gap-2 ml-auto">
                {showIKProcess && 'nextIKCategory' in lead && (
                    <IKProcessButton iconOnly lead={lead} permissions={lead.permissions} />
                )}
                {showAdvisorService && lead.permissions && (
                    <AdvisorServiceButton lead={lead} permissions={lead.permissions} />
                )}
                {addedAdvisorId && canHandOnAddedAdvisorShare({ lead, permissions: lead.permissions }) ? (
                    <ChangeAddedAdvisorButton
                        advisorId={addedAdvisorId}
                        iconOnly
                        lead={lead}
                        permissions={lead.permissions}
                    />
                ) : (
                    <ChangeAdviserButton
                        iconOnly
                        lead={lead}
                        originalLoanRequestId={originalLoanRequestId}
                        permissions={lead.permissions}
                    />
                )}
            </div>
        </div>
    );
};
